import { createFileRoute } from '@tanstack/react-router'
import { SegmentsPageClient } from '#/components/segments/SegmentsPageClient'

export const Route = createFileRoute('/_authenticated/$slug/settings/segments')({
  component: SegmentsPageClient,
})
